export default function toCapitalize(str) {
  if (typeof str !== 'string') {
    return '';
  }

  if (str.length < 2) {
    return str.toUpperCase();
  }

  const firstLetter = str.charAt(0);
  const rest = str.slice(1);
  return firstLetter.toUpperCase() + rest.toLowerCase();
}
